"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json_1 = require("../helpers/json");
var UsermetaModel = /** @class */ (function () {
    function UsermetaModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/usermeta",
            UPDATE: APPURL + "/api/v1/usermeta",
            CREATE: APPURL + "/api/v1/usermeta",
        };
        this.data = [];
        this.user = {};
        this.metadata = {};
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    UsermetaModel.prototype.extract = function (result) {
        return result.data;
    };
    UsermetaModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    // TODO: Turn meta data stored as json into objects
    UsermetaModel.prototype.cacheUser = function (result) {
        var _this = this;
        var user = this.extract(result);
        this.metadata = {};
        user.usermeta.forEach(function (meta) {
            _this.metadata[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                ? JSON.parse(meta.meta_value)
                : meta.meta_value;
        });
        user.usermeta = this.metadata;
        return user;
    };
    UsermetaModel.prototype.getUserByID = function (userId) {
        return this.$http
            .get(this.URLS.FETCH + "/" + userId)
            .then(this.cacheResults);
    };
    UsermetaModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    UsermetaModel.prototype.update = function (meta) {
        var id = meta.user_id ? meta.user_id : meta.meta_id;
        return this.$http
            .put(this.URLS.FETCH + "/" + id, meta)
            .then(this.cacheResults);
    };
    UsermetaModel.prototype.delete = function (user) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + user.id)
            .then(this.cacheResults);
    };
    return UsermetaModel;
}());
UsermetaModel.$inject = ["$http", "APPURL"];
exports.default = UsermetaModel;
